export default [
  {
    path: "/parking",
    component: () => import("@/pages/parking/parking-list.vue"),
    meta: {
      requiredLevel: ["admin", "perhubungan"],
    },
  },
  {
    path: "/parking/import/",
    component: () => import("@/pages/parking/parking-import.vue"),
    meta: {
      requiredLevel: ["admin", "perhubungan"],
    },
  },
];
